import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfigurationModel} from "../configuration.model";
import {Subject} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {ConfigurationDataService} from "../configuration-data.service";
import {instanceToInstance} from "class-transformer";
import {ConfigurationDataEditComponent} from "../configuration-data-edit/configuration-data-edit.component";
import {EditStateComponent} from "web-shared";

@Component({
  selector: 'app-configuration-data-edit-state',
  template: `
    <app-toolbar>
      <app-breadcrumbs>
      </app-breadcrumbs>
      <app-toolbar-edit-buttons [saveState$]="saveState$"
                                [deleteState$]="deleteState$"
                                (save)="save()"
                                (delete)="delete()">
      </app-toolbar-edit-buttons>
    </app-toolbar>
    <app-configuration-data-edit [configuration]="configuration"
                                 [readonly]="readonly"
                                 [currentTab]="currentTab"
                                 [shouldResetSaveState$]="shouldResetSaveState$"
                                 [wasValidated$]="wasValidated$"
                                 (setTab)="currentTab = $event"
                                 (changed)="onChanged($event)"></app-configuration-data-edit>`,
})
export class ConfigurationDataEditStateComponent extends EditStateComponent implements OnInit {
  configuration: ConfigurationModel;
  currentTab: string;
  wasValidated$: Subject<boolean> = new Subject<boolean>();
  @ViewChild(ConfigurationDataEditComponent, {static: true}) editComponent: ConfigurationDataEditComponent;

  constructor(private route: ActivatedRoute, private configurationDataService: ConfigurationDataService) {
    super();
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.componentDestroyed)).subscribe(routeParams => {
      this.currentTab = routeParams.tab ?? 'general';
      this.configuration = this.route.snapshot.data.entity as ConfigurationModel;
    });
  }

  onChanged(isPristine: boolean) {
    this.triggerChanges(!isPristine);
  }

  save() {
    this.wasValidated$.next(true);
    if (this.configuration.isValid()) {
      this.configurationDataService.save(this.configuration).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        this.configuration = instanceToInstance(value);
        this.editComponent.initialize(this.configuration);
        this.shouldResetSaveState$.next(true);
      });
    } else {
      this.currentTab = 'general';
    }
  }

  delete() {
    this.configurationDataService.remove(this.configuration).subscribe(() => {
      this.router.navigate(['/']).catch(reason => console.error(reason));
    });
  }
}
